import { motion } from "framer-motion";
import { useInView } from "framer-motion";
import { useRef } from "react";
export default function ProgressBar({
  label,
  percentage,
  count,
  delay = 0,
}) {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-50px" });

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 20 }}
      animate={isInView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.5, delay }}
      className="flex flex-col gap-3"
    >
      <div className="flex justify-between items-center">
        <p className="text-gray-200 text-base sm:text-lg">{label}</p>
        <div className="flex items-center gap-4">
          <p className="text-white text-lg sm:text-xl">{percentage}%</p>
          <p className="text-coral text-sm sm:text-base">{count}</p>
        </div>
      </div>
      <div className="relative h-10 rounded-full item-border border-white/5 bg-white/10 overflow-hidden">
        <motion.div
          className="absolute inset-0 rounded-full"
          style={{
            background: "linear-gradient(90deg, #D4B896 0%, rgba(255, 255, 255, 0.30) 100%)",
          }}
          initial={{ width: "0%" }}
          animate={isInView ? { width: `${percentage}%` } : {}}
          transition={{ duration: 1, delay: delay + 0.2, ease: "easeOut" }}
        >
          <div
            className="absolute inset-0"
            style={{
              background: "linear-gradient(0deg, rgba(0, 0, 0, 0.10) 0%, rgba(0, 0, 0, 0.00) 100%)",
            }}
          />
        </motion.div>
      </div>
    </motion.div>
  );
}
